export const createFilters = (defs) => {
    return defs;
};
